
export const isCardioExercise = (exercise: any) => {
  if (!exercise) return false;
  const name = exercise.name?.toLowerCase() || '';
  const bodyPart = exercise.body_part?.toLowerCase() || '';
  const targetMuscle = exercise.target_muscle?.toLowerCase() || '';

  // Check if it's a cardio exercise by name
  if (name.includes('cardio') || name.includes('corrida') || 
      name.includes('esteira') || name.includes('bicicleta') ||
      name.includes('running') || name.includes('treadmill') ||
      name.includes('cycling') || name.includes('bicycle') || 
      name.includes('aeróbico') || name.includes('aerobic')) {
    return true;
  }

  // Check if it's a cardio exercise by body part or target muscle
  if (bodyPart.includes('cardio') || targetMuscle.includes('cardio') ||
      bodyPart.includes('aerobic') || targetMuscle.includes('aerobic') ||
      bodyPart === 'cardiovascular' || targetMuscle === 'cardiovascular') {
    return true;
  }

  // Check if it has time specified but no reps
  if (exercise.time && (!exercise.reps || exercise.reps === '')) {
    return true;
  }

  return false;
};
